
import React, { useContext } from "react";
import { FaCheckDouble, FaAward, FaChartLine, FaUsersCog } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './AuditGlobal.css';
import BannerImage from './audit_hero.png';

function ISO9K1() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-9001-audit');
    } else {
      navigate('/login', { state: { from: '/booking/iso-9001-audit' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Quality Audit</span>
          <h1 className="hero-title">ISO 9001 Audit</h1>
          <p className="hero-subtitle">
            Ensuring excellence in every process. Validating your Quality Management System
            for consistency and customer satisfaction.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Audit <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Benchmark of Quality</h2>
              <p className="article-text">
                In a competitive market, quality is the differentiator. An ISO 9001 Audit confirms that your organization
                delivery consistent products and services. It focuses on the "Process Approach" and "Risk-based Thinking".
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Core Audit Components</h2>
              <p className="article-text">
                The auditor verifies:
                <br />- <strong>Customer Focus:</strong> Are client requirements clearly understood?
                <br />- <strong>Leadership:</strong> Is management accountable for quality?
                <br />- <strong>Operations:</strong> Are production and service provision controlled?
                <br />- <strong>Improvement:</strong> Is the PDCA cycle active?
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Business Impact</h2>
              <p className="article-text">
                A clean audit report builds trust. It tells your customers that you have robust systems in place
                to handle their needs, and that you are committed to continuous improvement.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">QMS Pillars</h4>
              <ul className="key-list">
                <li><FaUsersCog className="check-icon" /> Customer Satisfaction</li>
                <li><FaChartLine className="check-icon" /> Process Efficiency</li>
                <li><FaCheckDouble className="check-icon" /> Product Conformity</li>
                <li><FaAward className="check-icon" /> Continual Improvement</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Start your journey to ISO 9001 certification.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO9K1;
